import { SectionDrawn } from '../../Section';

export const getSectionsTotalDrawnSurface = (sections: SectionDrawn[]) =>
  sections.reduce((acc, section) => acc + section.surface, 0);
